<template>
  <XBaseTextarea
    :inputClass="inputClasses"
    :value="value"
    v-bind="attrAndProps"
    v-on="$listeners">
    <template slot="hint">
      <slot name="hint" />
    </template>
    <template slot="extra">
      <slot name="extra" />
    </template>
  </XBaseTextarea>
</template>

<script>
import XBaseTextarea from '@common/components/BaseTextarea'

const INHERIT_PROPS = XBaseTextarea.mixins.reduce((carry, mixin) => ({ ...carry, ...mixin.props }), XBaseTextarea.props)

export default {
  components: { XBaseTextarea },

  props: {
    ...INHERIT_PROPS,

    color: {
      type: String,
      default: 'primary'
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    inputClasses () {
      return [...DEFAULT_INPUT_CLASSES, ...COLORS[this.color], {
        'cursor-not-allowed text-grey-60': this.disabled,
        'text-grey-40': !this.disabled,
        'border-danger-60 shadow-outline-danger': this.invalid
      }]
    },

    attrAndProps () {
      return {
        ...this.$props,
        ...this.$attrs
      }
    }
  }
}

const DEFAULT_INPUT_CLASSES = [
  'w-full',
  'bg-white',
  'rounded',
  'border',
  'border-solid',
  'border-grey-80',
  'py-2',
  'px-3',
  'outline-none'
]

const COLORS = {
  primary: [
    'focus:shadow-outline-info',
    'focus:border-info-50'
  ],
  secondary: [
    'focus:shadow-outline-info',
    'focus:border-info-50'
  ],
  danger: [
    'focus:shadow-outline-danger',
    'focus:border-danger-50'
  ]
}
</script>
